import { createFileRoute } from "@tanstack/react-router";

import CompetitionProfile from "@/components/CompetitionProfile/CompetitionProfile";

const Component = () => {
  const { competitionUuid } = Route.useParams();
  return <CompetitionProfile competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/profile")({
  component: Component,
});
